import { ExperimentsProvider, useExperiments } from '@wix/wix-experiments-react';
import React from 'react';
export const NEW_PLAN_FEATURES_MODAL_SPEC = 'newPlanFeaturesModal';
export const SdkExperimentsProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ExperimentsProvider, {
    scope: "premium-package-pickers"
  }, children);
};
export const useIsNewPlanFeaturesModal = () => {
  const {
    ready,
    experiments
  } = useExperiments({
    suspense: false
  });
  return {
    ready,
    isNewPlanFeaturesModal: experiments.enabled(NEW_PLAN_FEATURES_MODAL_SPEC)
  };
};
//# sourceMappingURL=index.js.map